document.addEventListener('DOMContentLoaded', function () {

  const modal = document.querySelector('.product-question-modal');

  if (!modal) return;

  const overlay = modal.querySelector('.product-question-overlay');
  const closeButton = modal.querySelector('.product-question-close');
  const submitButton = modal.querySelector('.product-question-submit');
  const textarea = modal.querySelector('.product-question-textarea');
  const variantDisplay = modal.querySelector('.product-question-variant');

  const questionButton = document.querySelector('.product-question-button');

  if (!questionButton) return;


  function getCurrentVariantTitle() {

    const variantInput = document.querySelector(
      '.product-form input[name="id"]'
    );

    if (!variantInput) {
      return '';
    }

    const variantId = variantInput.value;

    if (!window.productQuestionVariants) {
      return '';
    }

    const variant = window.productQuestionVariants.find(
      function (item) {
        return String(item.id) === String(variantId);
      }
    );

    return variant ? variant.title : '';
  }


  function openModal() {

    const variantTitle = getCurrentVariantTitle();

    if (variantTitle && variantDisplay) {
      variantDisplay.textContent = variantTitle;
    }

    modal.hidden = false;

    document.body.classList.add(
      'product-question-open'
    );

    setTimeout(function () {

      if (textarea) {
        textarea.focus();
      }

    }, 100);

  }


  function closeModal() {

    modal.hidden = true;

    document.body.classList.remove(
      'product-question-open'
    );

  }


  questionButton.addEventListener(
    'click',
    openModal
  );


  closeButton.addEventListener(
    'click',
    closeModal
  );


  overlay.addEventListener(
    'click',
    closeModal
  );


  document.addEventListener(
    'keydown',
    function (event) {

      if (
        event.key === 'Escape' &&
        !modal.hidden
      ) {

        closeModal();

      }

    }
  );


  submitButton.addEventListener(
    'click',
    function () {

      const question =
        textarea.value.trim();

      if (!question) {

        textarea.focus();

        return;

      }


      const productName =
        document.querySelector(
          '.product__title h1, .product__title'
        )?.textContent.trim()
        || 'Product';


      const variantTitle =
        getCurrentVariantTitle();


      const message =
        'مرحبًا، لدي استفسار عن المنتج:%0A%0A' +

        'المنتج: ' +
        encodeURIComponent(productName) +

        '%0A' +

        'الاختيار: ' +
        encodeURIComponent(variantTitle) +

        '%0A%0A' +

        'الاستفسار: ' +
        encodeURIComponent(question);


      const whatsappURL =
        'https://wa.me/201001223405?text=' +
        message;


      window.open(
        whatsappURL,
        '_blank'
      );

    }
  );

});